/**
 * Normalize ignition (ACC) status safely
 *
 * @param {*} rawAcc        - acc value from socket / api
 */
export const normalizeAcc = (rawAcc) => {
  if (rawAcc === true) return true;
  if (rawAcc === false) return false;

  if (typeof rawAcc === 'number') return rawAcc === 1;

  if (typeof rawAcc === 'string') {
    const v = rawAcc.toLowerCase();
    if (['1', 'on', 'true', 'yes'].includes(v)) return true;
    if (['0', 'off', 'false', 'no'].includes(v)) return false;
  }

  // Frontend should not derive ignition OFF when data is missing/ambiguous.
  return null;
};
